import {Provider} from "@angular/core";
import {TEST_MODULE_REGISTRY, TestModuleDefinition} from "../../../core/shared/test/data/test-harness.types";
import {
    NsNotificationObjectComponent
} from "../component/protected-components/notification-object-component/ns-notification-object.component";
import {
    NsNotificationTypeObjectComponent
} from "../component/object-components/ns-notification-type-object-component/ns-notification-type-object.component";
import {
    NsNotificationSendComponent
} from "../component/protected-components/ns-notification-send/ns-notification-send.component";
import {
    NsNotificationTypesForObjectComponent
} from "../component/protected-components/ns-notification-types-for-object/ns-notification-types-for-object.component";
import {
    NsNotificationCommentWfProcessStepMainActivityComponent
} from "../component/protected-components/wf/ns-notification-comment-wf-process-step-main-activity/ns-notification-comment-wf-process-step-main-activity.component";
import {
    NsNotificationCommentWfProcessStepSideActivityComponent
} from "../component/protected-components/wf/ns-notification-comment-wf-process-step-side-activity/ns-notification-comment-wf-process-step-side-activity.component";

const nsModuleEntry: TestModuleDefinition = {
    key: 'ns',
    label: 'Notification (ns)',
    components: [
        {
            key: 'NsNotificationObjectComponent',
            component: NsNotificationObjectComponent,
            selector: 'mvs-ns-notification-object-component',
            label: 'Notification Object',
            type: 'ObjectBaseComponent'
        },
        {
            key: 'NsNotificationTypeObjectComponent',
            component: NsNotificationTypeObjectComponent,
            selector: 'mvs-ns-notification-type-object',
            label: 'Notification Type Object',
            type: 'ObjectBaseComponent'
        },
        {
            key: 'NsNotificationSendComponent',
            component: NsNotificationSendComponent,
            selector: 'mvs-ns-notification-send',
            label: 'Notification Send',
            type: 'Component',
        },
        {
            key: 'NsNotificationTypesForObjectComponent',
            component: NsNotificationTypesForObjectComponent,
            selector: 'mvs-ns-notification-types-for-object',
            label: 'Notification Types',
            type: 'Component',
        },
        {
            key: 'NsNotificationCommentWfProcessStepMainActivityComponent',
            component: NsNotificationCommentWfProcessStepMainActivityComponent,
            selector: 'mvs-wf-process-step-activity-object-notification',
            label: 'Notification Workflow Step Main Activity',
            type: 'Component',
        },
        {
            key: 'NsNotificationCommentWfProcessStepSideActivityComponent',
            component: NsNotificationCommentWfProcessStepSideActivityComponent,
            selector: 'mvs-wf-process-step-activity-object-notification',
            label: 'Notification Workflow Side Activity',
            type: 'Component',
        },
    ]

}

export const NS_TEST_PROVIDERS: Provider[] = [
    {
        provide: TEST_MODULE_REGISTRY, useValue: nsModuleEntry, multi: true
    }
]